module.exports = __webpack_public_path__ + "img/authentication-ico01@2x.fc6bfb1f.png";